import { render } from "./NewProductSupplierModal.vue?vue&type=template&id=b428a454"
import script from "./NewProductSupplierModal.vue?vue&type=script&lang=js"
export * from "./NewProductSupplierModal.vue?vue&type=script&lang=js"
script.render = render

export default script